import EventService from '../../../helpers/classes/EventService';
import RenderingService from '../../../helpers/classes/RenderingService';
import TemplateService from '../../../helpers/classes/TemplateService';
import { JourneyContainer } from '../../classes/JourneyContainer';
import JourneyManager from '../../classes/JourneyManager';
import { JourneyEvent } from '../../enums/JourneyEvent';
import { Templates } from '../../enums/Templates';
import { ImageProvider } from './image';
import { IMetaData } from '../../interfaces/MetaData';
import { FlowState } from '../../enums/FlowState';
import { ImageService } from '../../../helpers/classes/ImageService';
import { RequiredInputImage } from '../../enums/RequiredInputImage';
import DataService, { DataStoreType } from '../../classes/DataService';
import { IIdScanData } from '../../interfaces/DataFormats';
import { Journey } from '../../classes/Journey';
import { TranslationKey } from '../../enums/Translation';
import LanguageService from '../../../helpers/classes/LanguageService';
import {
	removeItems,
} from '../../../helpers/functions/arrays';
import { TripleScanGuidanceProvider } from './triple-scan-guidance';
import { InputProvider } from '../../enums/InputProvider';

export class FileSystemProvider {

	public static render(this: JourneyContainer, isFromTripleScanGuidancePage: boolean = false) {
		return TemplateService.getElements(this._container, {
			providerContainer: '[data-jcs-element="provider__container"]',
		})
			.then(({ providerContainer }) => TemplateService.renderToContainer(providerContainer, Templates.Filesystem))
			.then((providerContainer) => TemplateService.getElements(providerContainer, {
				fileUploadButton: '[data-jcs-element="file__input__Button"]',
				fileInput: '[data-jcs-element="file__input"]',
				dropbox: '[data-jcs-element="file__drop__box"]',
				fileTooLargeError: '[data-jcs-element="file__too__large__error"]',
				invalidFileFormatError: '[data-jcs-element="invalid__format__error"]',
				openPreviewInfoId: '[data-jcs-element="preview__page__open__info__id"]',
				openPreviewInfoFM: '[data-jcs-element="preview__page__open__info__fm"]',
				openPreviewInfoPOA: '[data-jcs-element="preview__page__open__info__poa"]',
				openPreviewInfoCovid: '[data-jcs-element="preview__page__open__info__covid"]',
				previewInfoContainerId: '[data-jcs-element="preview__info__container__id"]',
				previewInfoContainerFM: '[data-jcs-element="preview__info__container__fm"]',
				previewInfoContainerPOA: '[data-jcs-element="preview__info__container__poa"]',
				previewInfoContainerCovid: '[data-jcs-element="preview__info__container__covid"]',
				closePreviewInfoId: '[data-jcs-element="preview__page__close__info__id"]',
				closePreviewInfoFM: '[data-jcs-element="preview__page__close__info__fm"]',
				closePreviewInfoPOA: '[data-jcs-element="preview__page__close__info__poa"]',
				closePreviewInfoCovid: '[data-jcs-element="preview__page__close__info__covid"]',
				attemptCountContainer: '[data-jcs-element="attempt__count__container"]',
				attemptCounter: '[data-jcs-element="attempt__counter"]',
				idDocumentContainer: '[data-jcs-element="identity__document__file__upload"]',
				facematchContainer: '[data-jcs-element="facematch__file__upload"]',
				addressContainer: '[data-jcs-element="address__file__upload"]',
				covidContainer: '[data-jcs-element="covid__file__upload"]',
				uploading: '[data-jcs-element="uploading__file__without__preview"]',
				supportedTypes: '[data-jcs-element="supported__types"]',
				supportedTypesSelfie: '[data-jcs-element="supported__types__selfie"]',
				action: '[data-jcs-element="info__journey__action"]'

			}))
			.then(({ fileUploadButton, fileInput, dropbox, fileTooLargeError, invalidFileFormatError, openPreviewInfoId, openPreviewInfoFM, openPreviewInfoPOA, openPreviewInfoCovid, previewInfoContainerId, previewInfoContainerFM, previewInfoContainerPOA, previewInfoContainerCovid, closePreviewInfoId, closePreviewInfoFM, closePreviewInfoPOA, closePreviewInfoCovid, attemptCountContainer, attemptCounter, idDocumentContainer, facematchContainer, addressContainer, covidContainer, uploading, supportedTypes, supportedTypesSelfie, action }) => {
				RenderingService.hideObject(previewInfoContainerId);
				RenderingService.hideObject(previewInfoContainerFM);
				RenderingService.hideObject(previewInfoContainerPOA);
				RenderingService.hideObject(previewInfoContainerCovid);
				RenderingService.hideObject(closePreviewInfoId);
				RenderingService.hideObject(closePreviewInfoFM);
				RenderingService.hideObject(closePreviewInfoPOA);
				RenderingService.hideObject(closePreviewInfoCovid);
				RenderingService.hideObject(idDocumentContainer);
				RenderingService.hideObject(facematchContainer);
				RenderingService.hideObject(addressContainer);
				RenderingService.hideObject(covidContainer);
				RenderingService.hideObject(uploading);
				RenderingService.hideObject(supportedTypes);
				RenderingService.hideObject(supportedTypesSelfie);
				RenderingService.hideObject(dropbox);
				if (this._journey) {
					// Check if triple scan guidance page mode is enabled & journey is on triple scan state
					if (this._journey.actionAttempt > 1 &&
						this._config.tripleScanGuidancePage && ((this._journey.action === FlowState.IDENTITY_BACK) || (this._journey.action === FlowState.IDENTITY_FRONT)) &&
						!isFromTripleScanGuidancePage &&
						!this._retry) {

						TripleScanGuidanceProvider.render.call(this, InputProvider.FILESYSTEM);
					}
					else {
						isFromTripleScanGuidancePage = false;
						RenderingService.showObject(dropbox);

						switch (this._journey.action) {
							case FlowState.SELFIE:
								RenderingService.showObject(facematchContainer);
								RenderingService.showObject(supportedTypesSelfie);
								break;
							case FlowState.IDENTITY_BACK:
							case FlowState.IDENTITY_FRONT:
								RenderingService.showObject(idDocumentContainer);
								RenderingService.showObject(supportedTypes);
								RenderingService.setText(
									action,
									LanguageService.getTranslation(
										`FLOW_STATE_${this._journey.action}` as TranslationKey
									)
								);
								break;
							case FlowState.ADDRESS:
								RenderingService.showObject(addressContainer);
								RenderingService.showObject(supportedTypes);
								break;
							case FlowState.COVIDPASS:
								RenderingService.showObject(covidContainer);
								RenderingService.showObject(supportedTypes);
								break;
						}
					}

					switch (this._journey.actionAttempt) {
						case 2:
							RenderingService.setText(attemptCounter, '2');
							break;
						case 3:
							RenderingService.setText(attemptCounter, '1');
							break;
						default:
							RenderingService.hideObject(attemptCountContainer);
							break;
					}

					this._retry = false;
				}


				if (openPreviewInfoId instanceof HTMLElement) {
					openPreviewInfoId.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerId);
						RenderingService.showObject(closePreviewInfoId);
						RenderingService.hideObject(openPreviewInfoId);
					});
				}

				if (openPreviewInfoFM instanceof HTMLElement) {
					openPreviewInfoFM.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerFM);
						RenderingService.showObject(closePreviewInfoFM);
						RenderingService.hideObject(openPreviewInfoFM);
					});
				}

				if (openPreviewInfoPOA instanceof HTMLElement) {
					openPreviewInfoPOA.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerPOA);
						RenderingService.showObject(closePreviewInfoPOA);
						RenderingService.hideObject(openPreviewInfoPOA);
					});
				}

				if (openPreviewInfoCovid instanceof HTMLElement) {
					openPreviewInfoCovid.addEventListener('click', () => {
						RenderingService.showObject(previewInfoContainerCovid);
						RenderingService.showObject(closePreviewInfoCovid);
						RenderingService.hideObject(openPreviewInfoCovid);
					});
				}

				if (closePreviewInfoId instanceof HTMLElement) {
					closePreviewInfoId.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerId);
						RenderingService.hideObject(closePreviewInfoId);
						RenderingService.showObject(openPreviewInfoId);
					});
				}

				if (closePreviewInfoFM instanceof HTMLElement) {
					closePreviewInfoFM.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerFM);
						RenderingService.hideObject(closePreviewInfoFM);
						RenderingService.showObject(openPreviewInfoFM);
					});
				}

				if (closePreviewInfoPOA instanceof HTMLElement) {
					closePreviewInfoPOA.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerPOA);
						RenderingService.hideObject(closePreviewInfoPOA);
						RenderingService.showObject(openPreviewInfoPOA);
					});
				}

				if (closePreviewInfoCovid instanceof HTMLElement) {
					closePreviewInfoCovid.addEventListener('click', () => {
						RenderingService.hideObject(previewInfoContainerCovid);
						RenderingService.hideObject(closePreviewInfoPOA);
						RenderingService.showObject(openPreviewInfoCovid);
					});
				}

				if (fileInput instanceof HTMLInputElement) {
					if (fileUploadButton instanceof HTMLElement) {
						fileUploadButton.addEventListener('click', () => {
							const event = new MouseEvent('click');
							fileInput.dispatchEvent(event);
						});
					}
					switch (this._journey!.action) {
						case FlowState.SELFIE:
							fileInput.accept = removeItems(this.getAllowedFileFormats(), "application/pdf").join(', ');
							break;
						default:
							fileInput.accept = this.getAllowedFileFormats().join(', ');
							break;
					}
					fileInput.addEventListener('change', FileSystemProvider.fileSelectHandler.bind(this), false);
				}
				RenderingService.hideObject(fileTooLargeError);
				RenderingService.hideObject(invalidFileFormatError);

				if (dropbox && RenderingService.supportsDragDrop()) {
					dropbox.addEventListener('dragover', FileSystemProvider.fileDragHover.bind(this), false);
					dropbox.addEventListener('dragleave', FileSystemProvider.fileDragHover.bind(this), false);
					dropbox.addEventListener('drop', FileSystemProvider.fileDropHandler.bind(this), false);
				}
			})
			.then(() => EventService.publish(JourneyEvent.DISPLAY_PROVIDER, { provider: Templates.Filesystem }));
	}

	private static continueJourney(this: JourneyContainer, image: string, metaData: IMetaData[]) {
		if (this._journey !== undefined) {
			switch (this._journey.action) {
				case FlowState.IDENTITY_BACK:
				case FlowState.IDENTITY_FRONT:
					return ImageProvider.render.call(this, image, metaData);
				case FlowState.ADDRESS:
					return ImageProvider.render.call(this, image, metaData);
				case FlowState.SELFIE:
					return ImageProvider.render.call(this, image, metaData);
				case FlowState.COVIDPASS:
					return ImageProvider.render.call(this, image, metaData);
			}
		}
	}

	private static continueJourneySkipPreview(this: JourneyContainer, image: string, metaData: IMetaData[]) {
		const { type } = ImageService.getBase64Components(image);
		return this.assertImageExists(image)
			.then(() => this.getJourney())
			.then((journey) => journey.continue({
				imgList: [{
					...ImageService.remapNames(ImageService.getBase64Components(image)),
					name: journey.action === 'SELFIE' ? RequiredInputImage.SelfiePhoto : RequiredInputImage.WhiteImage,
					inputFormat: type === 'pdf' ? 1 : 0
				}],
				journeyDefinitionId: this._journeyDefinitionId
			}, metaData)
				.then((res) => DataService.getDataStore<IIdScanData>(DataStoreType.ID_SCAN).update(ImageProvider.parseResponseData(res)))
				.then(() => this.evaluate)
				.then(this.updateJourneyFields));
	}

	/**
	 * If dragover event is triggered on dropbox, assigns hover class to the dropbox
	 * @param e
	 */
	private static fileDragHover(this: JourneyContainer, e: any) {
		e.stopPropagation();
		e.preventDefault();

		TemplateService.getElements(this._container, {
			fileDropBox: '[data-jcs-element="file__drop__box"]',
		}).then(({ fileDropBox }) => {
			if (e.type === 'dragover') {
				RenderingService.addClass(fileDropBox, 'dragover');
			} else {
				RenderingService.removeClass(fileDropBox, 'dragover');
			}
		});
	}

	private static async fileDropHandler(this: JourneyContainer, e: DragEvent) {
		FileSystemProvider.fileDragHover.call(this, e);

		const [file] = Array.from((e.dataTransfer ? e.dataTransfer.files : []));
		const metaData: IMetaData[] = [];
		if (await FileSystemProvider.checkAndShowErrors(this, this._container, file)) {
			return;
		}
		return TemplateService.getElements(this._container, {
			uploading: '[data-jcs-element="uploading__file__without__preview"]'
		}).then(({ uploading }) => {
			if (file.type === 'application/pdf' && this._journey!.action != FlowState.SELFIE) {
				RenderingService.showObject(uploading);
				FileSystemProvider.skipPreviewAndUpload.call(this, file, metaData).then(() => RenderingService.hideObject(uploading));
			} else {
				return JourneyManager.toBase64(file)
					.then((base64) => FileSystemProvider.continueJourney.call(this, base64, metaData))
					.then(() => this.updateJourneyFields());
			}
		});
	}

	private static async fileSelectHandler(this: JourneyContainer, e: Event) {
		const [file] = Array.from(((e.currentTarget as HTMLInputElement).files || []));
		const metaData: IMetaData[] = [];
		if (await FileSystemProvider.checkAndShowErrors(this, this._container, file)) {
			return;
		}
		return TemplateService.getElements(this._container, {
			uploading: '[data-jcs-element="uploading__file__without__preview"]'
		}).then(({ uploading }) => {
			if (file.type === 'application/pdf' && this._journey!.action != FlowState.SELFIE) {
				RenderingService.showObject(uploading);
				FileSystemProvider.skipPreviewAndUpload.call(this, file, metaData).then(() => RenderingService.hideObject(uploading));
			} else {
				EventService.publish(JourneyEvent.DISPLAY_INFO, { fileName: file.name, fileSize: file.size, fileType: file.type });
				return JourneyManager.toBase64(file)
					.then((base64) => FileSystemProvider.continueJourney.call(this, base64, metaData))
					.then(() => this.updateJourneyFields());
			}
		});
	}

	private static async skipPreviewAndUpload(this: JourneyContainer, file: File, metaData: IMetaData[]) {
		const base64 = await JourneyManager.toBase64(file);
		return this.assertImageExists(base64)
			.then(() => this.getJourney())
			.then((journey) => journey.continue({
				imgList: [{
					...ImageService.remapNames(ImageService.getBase64Components(base64)),
					name: journey.action === 'SELFIE' ? RequiredInputImage.SelfiePhoto : RequiredInputImage.WhiteImage,
					inputFormat: 1
				}],
				journeyDefinitionId: this._journeyDefinitionId
			}, metaData)
				.then((res) => DataService.getDataStore<IIdScanData>(DataStoreType.ID_SCAN).update(ImageProvider.parseResponseData(res)))
				.then(() => this.evaluate())
				.then(this.updateJourneyFields));
	}

	private static checkAndShowErrors(container: JourneyContainer, htmlContainer: HTMLElement, file: File): Promise<boolean> {
		return TemplateService.getElements(htmlContainer, {
			fileTooLargeError: '[data-jcs-element="file__too__large__error"]',
			invalidFileFormatError: '[data-jcs-element="invalid__format__error"]',
			dropbox: '[data-jcs-element="file__drop__box"]',
		}).then(({ fileTooLargeError, invalidFileFormatError, dropbox }) => {
			if (file) {
				RenderingService.hideObject(invalidFileFormatError);
				RenderingService.hideObject(fileTooLargeError);
				if (container.getAllowedFileFormats().indexOf(file.type) < 0) {
					RenderingService.showObject(invalidFileFormatError);
					RenderingService.addClass(dropbox, 'error');
					return true;
				}
				if (file.size > 7864320) {
					RenderingService.showObject(fileTooLargeError);
					RenderingService.addClass(dropbox, 'error');
					return true;
				}
				return false;
			}
			return true;
		});
	}
}
